export const dashboardProductsSlider = (instance, options) => {
    const responsiveItemCounts = {
        1024: 3,
        1280: 2,
        1800: 3,
    }

    let breakpoints = {}
    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 12,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}
